import { useTranslation } from "react-i18next";
import PrivacyFooter from "../../../widgets/footer/PrivacyFooter";
import PrivacyHeader from "../../../widgets/header/PrivacyHeader";
import { Seo } from "../../../shared/seo/Seo";
import { LegalJsonLd } from "../../../shared/seo/JsonLd";

const ClientAppTerms = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language === "ru" ? "ru" : "uz";

  return (
    <>
      <Seo path="/client-app/terms" lang={lang} />
      <LegalJsonLd lang={lang} path="/client-app/terms" />
      {/* Header and footer sit outside the container so they span the full width, as on the
          business-app legal pages. */}
      <PrivacyHeader />
      <div className="container mx-auto px-4 py-8">
        <main className="mx-auto border-t border-b border-[#E2E8F0] pt-8">
          <h1 className="text-3xl font-bold mb-6">{t('client_terms.title')}</h1>
          <p className="mb-2">
            <strong>{t('client_terms.effective_date')}</strong>
          </p>
          <p className="mb-6">
            <strong>{t('client_terms.last_update')}</strong>
          </p>
          <p className="mb-8">{t('client_terms.introduction')}</p>

          <h2 className="text-2xl font-semibold mb-4">{t('client_terms.description.title')}</h2>
          <p className="mb-4">{t('client_terms.description.intro')}</p>
          <ul className="list-disc pl-6 mb-8">
            {(t('client_terms.description.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
              <li key={index} className="mb-2">{item}</li>
            ))}
          </ul>

          <h2 className="text-2xl font-semibold mb-4">{t('client_terms.how_works.title')}</h2>
          <p className="mb-8">{t('client_terms.how_works.text')}</p>

          <h2 className="text-2xl font-semibold mb-4">{t('client_terms.features.title')}</h2>
          <ul className="list-disc pl-6 mb-8">
            {(t('client_terms.features.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
              <li key={index} className="mb-2">{item}</li>
            ))}
          </ul>

          <h2 className="text-2xl font-semibold mb-4">{t('client_terms.obligations.title')}</h2>
          <p className="mb-8">{t('client_terms.obligations.text')}</p>

          <h2 className="text-2xl font-semibold mb-4">{t('client_terms.liability.title')}</h2>
          <p className="mb-8">{t('client_terms.liability.text')}</p>

          <h2 className="text-2xl font-semibold mb-4">{t('client_terms.no_financial.title')}</h2>
          <p className="mb-8">{t('client_terms.no_financial.text')}</p>

          <h2 className="text-2xl font-semibold mb-4">{t('client_terms.termination.title')}</h2>
          <p className="mb-8">{t('client_terms.termination.text')}</p>

          <h2 className="text-2xl font-semibold mb-4">{t('client_terms.law.title')}</h2>
          <p className="mb-8">{t('client_terms.law.text')}</p>

          <h2 className="text-2xl font-semibold mb-4">{t('client_terms.contact.title')}</h2>
          <p className="mb-2">{t('client_terms.contact.email')}</p>
          <p className="mb-2">{t('client_terms.contact.phone')}</p>
          <p className="mb-8">{t('client_terms.contact.address')}</p>
        </main>
      </div>
      <PrivacyFooter />
    </>
  );
};

export default ClientAppTerms;
